import { FC, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Stack } from '@mui/system';

import NavigationItem from '@/shared/types/navigationItem.type';

import NavigationList from './components/NavigationList';
import Title from './components/Title';

const AccountSettings: FC = () => {
  const [activeNavigationItem, setActiveNavigationItem] =
    useState<NavigationItem | null>(null);

  return (
    <div>
      <Title activeNavigationItem={activeNavigationItem} />

      <Stack
        sx={{
          display: 'grid',
          gridTemplateColumns: 'minmax(300px, 400px) minmax(700px, 1fr)',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <NavigationList getActiveRoute={setActiveNavigationItem} />
        <Outlet />
      </Stack>
    </div>
  );
};

export default AccountSettings;
